import { redirect } from '@tanstack/react-router';

import { useUserStore } from '@/stores/user.store.ts';

export const Route = createFileRoute({
  loader() {
    const userStore = useUserStore.getState();

    // If user is not authenticated, redirect to log in
    if (!userStore?.user?.id || !userStore.user) {
      return redirect({ to: '/auth/sign-in' });
    }

    return redirect({ to: '/arc' });
  },
  component: Index,
});

function Index() {
  return <></>;
}
